<div class="list-toolbar">
    <mat-form-field
        *ngIf="filterText"
        class="search-input">
        <i matPrefix class="tce-icon-search"></i>
        <input matInput (keyup)="filter($event.target.value)" [placeholder]="filterText">
    </mat-form-field>
    <ng-content select="[itemListFilter]"></ng-content>
</div>

<mat-table
       [dataSource]="dataSource"
       matSort
       [matSortActive]="enableHeaderSort ? 'entity' : ''"
       [matSortDirection]="enableHeaderSort ? 'asc' : ''"
       [matSortDisabled]="!enableHeaderSort"
       matSortDisableClear>
    <ng-container matColumnDef="entity">
        <mat-header-cell *matHeaderCellDef
                         mat-sort-header
                         [disabled]="!enableHeaderSort">{{ header }}</mat-header-cell>
        <mat-cell *matCellDef="let posItem">
            <div class="item-desc">
                <div class="item-name">
                     {{posItem?.[listKey]}}</div>
                <div *ngIf="posItem?.alcohol?.enabled"
                     class="item-alcohol">{{ 'brand.settings.generalSettings.alcohol' | translate }} </div>
                <i class="tce-icon-warning"
                   *ngIf="posItem?.selectDisabled"
                   [attr.title]="disabledLabel | translate">
                 </i>
            </div>
            <div class="item-sku"
                 *ngIf="posItem?.['skuNumber']"
                 title="{{posItem?.['skuNumber']}}">
                {{posItem?.['skuNumber']}}
            </div>
        </mat-cell>
    </ng-container>

    <ng-container
        matColumnDef="select">
        <mat-header-cell
            *matHeaderCellDef
            class="txp-item-list-select-column">
            <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [disabled]="checkDataForUniformKeys(data, selectionKeyValue) || disableSelectAll">
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell
            *matCellDef="let row"
            class="txp-item-list-select-column"
            >
            <mat-checkbox (click)="$event.stopPropagation();"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
                [disabled]="(selection?.selected?.length > 0 && selection.selected[0]?.[selectionKeyValue] !== row?.[selectionKeyValue]) || row?.selectDisabled">
            </mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container
        matColumnDef="type">
        <mat-header-cell
            *matHeaderCellDef
            class="txp-item-list-type">{{ typeHeader }}</mat-header-cell>
            <mat-cell *matCellDef="let posItem"
                    class="txp-item-list-type">
            <div class="item-name"> {{ typeKey ? posItem?.[typeKey] : abbreviatedItemLookupType[posItem?.rawPosLookupType]}} </div>
        </mat-cell>
    </ng-container>

    <ng-container
        matColumnDef="saved">
        <mat-header-cell
            *matHeaderCellDef
            class="txp-item-list-saved">&nbsp;</mat-header-cell>
        <mat-cell
            *matCellDef="let posItem"
            class="txp-item-list-saved">
            <!-- <i *ngIf="posItem.isSaved" class="tce-icon-circle-check"></i> -->
            <txp-button data-qa-label="UndoButton"
                        [style]="buttonStyle.ROWACTION"
                        (click)="handleDelete(posItem)"
                        icon="tce-icon-revert"
                        *ngIf="canUndo"
                        [attr.title]="'catalog.mappings.removeFromMappingTooltip' | translate"
                        [hidden]="posItem?.isSaved">
            </txp-button>
        </mat-cell>
    </ng-container>

    <ng-container
        matColumnDef="mapped">
        <mat-header-cell
            *matHeaderCellDef
            class="txp-item-list-mapped">&nbsp;</mat-header-cell>
        <mat-cell
            *matCellDef="let posItem"
            class="txp-item-list-mapped">
            <i class="tce-icon-link" [ngClass]="{ 'linked': posItem?.isMapped }"
               [attr.title]="'catalog.mappings.readyToMapTooltip' | translate"></i>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayColumns"></mat-row>

</mat-table>

<div *ngIf="hasCount"
    class="txp-item-list-footer">
    {{ selection?.selected?.length }} / {{dataSource?.data?.length}} {{ entitiesSelectedText ? entitiesSelectedText : 'menu.mappings.entitiesSelected' | translate }}
</div>
